// @ts-nocheck
/* eslint-disable */
/**
 * Generated by orval v8.13.0 🍺
 * Do not edit manually.
 * SUREnet aanvragen-public API
 * OpenAPI spec version: 1
 */
import { useMutation, useQuery } from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType,
} from '@tanstack/vue-query';

import { computed, unref } from 'vue';
import type { MaybeRef } from 'vue';

import type { AanvragenMuterenStartMutatieDto } from '../model/aanvragenMuterenStartMutatieDto';

import type { AanvragenMuterenStartMutatieMutatieDto } from '../model/aanvragenMuterenStartMutatieMutatieDto';

import type { MuterenStartMutatieViaOfferteParams } from '../model/muterenStartMutatieViaOfferteParams';

import type { Result1OfAanvragenMuterenMutatieActiesDto } from '../model/result1OfAanvragenMuterenMutatieActiesDto';

import { customInstance } from '../../customInstance';
import type { ErrorType } from '../../customInstance';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary Start een mutatie
 */
export const muterenStart = (
  polisnummerpakket: MaybeRef<string | undefined | null>,
  aanvragenMuterenStartMutatieMutatieDto?: MaybeRef<AanvragenMuterenStartMutatieMutatieDto>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  polisnummerpakket = unref(polisnummerpakket);
  aanvragenMuterenStartMutatieMutatieDto = unref(aanvragenMuterenStartMutatieMutatieDto);

  return customInstance<AanvragenMuterenStartMutatieDto>(
    {
      url: `/api/v1/muteren/${polisnummerpakket}`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json-patch+json' },
      data: aanvragenMuterenStartMutatieMutatieDto,
      signal,
    },
    options,
  );
};

export const getMuterenStartMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof muterenStart>>,
    TError,
    { polisnummerpakket: string | undefined | null; data?: AanvragenMuterenStartMutatieMutatieDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof muterenStart>>,
  TError,
  { polisnummerpakket: string | undefined | null; data?: AanvragenMuterenStartMutatieMutatieDto },
  TContext
> => {
  const mutationKey = ['muterenStart'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof muterenStart>>,
    { polisnummerpakket: string | undefined | null; data?: AanvragenMuterenStartMutatieMutatieDto }
  > = (props) => {
    const { polisnummerpakket, data } = props ?? {};

    return muterenStart(polisnummerpakket, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type MuterenStartMutationResult = NonNullable<Awaited<ReturnType<typeof muterenStart>>>;
export type MuterenStartMutationBody = AanvragenMuterenStartMutatieMutatieDto | undefined;
export type MuterenStartMutationError = ErrorType<void>;

/**
 * @summary Start een mutatie
 */
export const useMuterenStart = <TError = ErrorType<void>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof muterenStart>>,
      TError,
      {
        polisnummerpakket: string | undefined | null;
        data?: AanvragenMuterenStartMutatieMutatieDto;
      },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof muterenStart>>,
  TError,
  { polisnummerpakket: string | undefined | null; data?: AanvragenMuterenStartMutatieMutatieDto },
  TContext
> => {
  return useMutation(getMuterenStartMutationOptions(options), queryClient);
};
/**
 *  <br /> Required permissions:<br /> <ul> <li>Permission: Muteren.MutatieStarten</li></ul>
 * @summary Start een mutatie via een offerte
 */
export const muterenStartMutatieViaOfferte = (
  polisnummerPakket: MaybeRef<string | undefined | null>,
  params?: MaybeRef<MuterenStartMutatieViaOfferteParams>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  polisnummerPakket = unref(polisnummerPakket);
  params = unref(params);

  return customInstance<void>(
    {
      url: `/api/v1/muteren/${polisnummerPakket}/viaofferte`,
      method: 'POST',
      params: unref(params),
      signal,
    },
    options,
  );
};

export const getMuterenStartMutatieViaOfferteMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof muterenStartMutatieViaOfferte>>,
    TError,
    { polisnummerPakket: string | undefined | null; params?: MuterenStartMutatieViaOfferteParams },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof muterenStartMutatieViaOfferte>>,
  TError,
  { polisnummerPakket: string | undefined | null; params?: MuterenStartMutatieViaOfferteParams },
  TContext
> => {
  const mutationKey = ['muterenStartMutatieViaOfferte'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof muterenStartMutatieViaOfferte>>,
    { polisnummerPakket: string | undefined | null; params?: MuterenStartMutatieViaOfferteParams }
  > = (props) => {
    const { polisnummerPakket, params } = props ?? {};

    return muterenStartMutatieViaOfferte(polisnummerPakket, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type MuterenStartMutatieViaOfferteMutationResult = NonNullable<
  Awaited<ReturnType<typeof muterenStartMutatieViaOfferte>>
>;

export type MuterenStartMutatieViaOfferteMutationError = ErrorType<void>;

/**
 * @summary Start een mutatie via een offerte
 */
export const useMuterenStartMutatieViaOfferte = <TError = ErrorType<void>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof muterenStartMutatieViaOfferte>>,
      TError,
      {
        polisnummerPakket: string | undefined | null;
        params?: MuterenStartMutatieViaOfferteParams;
      },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof muterenStartMutatieViaOfferte>>,
  TError,
  { polisnummerPakket: string | undefined | null; params?: MuterenStartMutatieViaOfferteParams },
  TContext
> => {
  return useMutation(getMuterenStartMutatieViaOfferteMutationOptions(options), queryClient);
};
/**
 *  <br /> Required permissions:<br /> <ul> <li>Permission: Muteren.ProductMuteren</li></ul>
 * @summary Muteert een product van de offerte.
 */
export const muterenProductMuteren = (
  offertenummer: MaybeRef<string | undefined | null>,
  offerteproductId: MaybeRef<number | undefined | null>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  offertenummer = unref(offertenummer);
  offerteproductId = unref(offerteproductId);

  return customInstance<void>(
    { url: `/api/v1/muteren/${offertenummer}/${offerteproductId}`, method: 'POST', signal },
    options,
  );
};

export const getMuterenProductMuterenMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof muterenProductMuteren>>,
    TError,
    { offertenummer: string | undefined | null; offerteproductId: number | undefined | null },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof muterenProductMuteren>>,
  TError,
  { offertenummer: string | undefined | null; offerteproductId: number | undefined | null },
  TContext
> => {
  const mutationKey = ['muterenProductMuteren'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof muterenProductMuteren>>,
    { offertenummer: string | undefined | null; offerteproductId: number | undefined | null }
  > = (props) => {
    const { offertenummer, offerteproductId } = props ?? {};

    return muterenProductMuteren(offertenummer, offerteproductId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type MuterenProductMuterenMutationResult = NonNullable<
  Awaited<ReturnType<typeof muterenProductMuteren>>
>;

export type MuterenProductMuterenMutationError = ErrorType<void>;

/**
 * @summary Muteert een product van de offerte.
 */
export const useMuterenProductMuteren = <TError = ErrorType<void>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof muterenProductMuteren>>,
      TError,
      { offertenummer: string | undefined | null; offerteproductId: number | undefined | null },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof muterenProductMuteren>>,
  TError,
  { offertenummer: string | undefined | null; offerteproductId: number | undefined | null },
  TContext
> => {
  return useMutation(getMuterenProductMuterenMutationOptions(options), queryClient);
};
/**
 *  <br /> Required permissions:<br /> <ul> <li>Permission: Crm.RelatieInzien</li></ul>
 * @summary Haalt de pakketpolis mutatie acties op
 */
export const muterenGetMogelijkeMutatieActies = (
  pakketpolisnummer: MaybeRef<string | undefined | null>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  pakketpolisnummer = unref(pakketpolisnummer);

  return customInstance<Result1OfAanvragenMuterenMutatieActiesDto>(
    { url: `/api/v1/muteren/${pakketpolisnummer}/acties`, method: 'GET', signal },
    options,
  );
};

export const getMuterenGetMogelijkeMutatieActiesQueryKey = (
  pakketpolisnummer: MaybeRef<string | undefined | null>,
) => {
  return ['api', 'v1', 'muteren', pakketpolisnummer, 'acties'] as const;
};

export const getMuterenGetMogelijkeMutatieActiesQueryOptions = <
  TData = Awaited<ReturnType<typeof muterenGetMogelijkeMutatieActies>>,
  TError = ErrorType<void>,
>(
  pakketpolisnummer: MaybeRef<string | undefined | null>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof muterenGetMogelijkeMutatieActies>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getMuterenGetMogelijkeMutatieActiesQueryKey(pakketpolisnummer);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof muterenGetMogelijkeMutatieActies>>> = ({
    signal,
  }) => muterenGetMogelijkeMutatieActies(pakketpolisnummer, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: computed(
      () => unref(pakketpolisnummer) !== null && unref(pakketpolisnummer) !== undefined,
    ),
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof muterenGetMogelijkeMutatieActies>>, TError, TData>;
};

export type MuterenGetMogelijkeMutatieActiesQueryResult = NonNullable<
  Awaited<ReturnType<typeof muterenGetMogelijkeMutatieActies>>
>;
export type MuterenGetMogelijkeMutatieActiesQueryError = ErrorType<void>;

/**
 * @summary Haalt de pakketpolis mutatie acties op
 */

export function useMuterenGetMogelijkeMutatieActies<
  TData = Awaited<ReturnType<typeof muterenGetMogelijkeMutatieActies>>,
  TError = ErrorType<void>,
>(
  pakketpolisnummer: MaybeRef<string | undefined | null>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof muterenGetMogelijkeMutatieActies>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getMuterenGetMogelijkeMutatieActiesQueryOptions(pakketpolisnummer, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 *  <br /> Required permissions:<br /> <ul> <li>Permission: Muteren.ProductMuteren</li></ul>
 * @summary Maakt een mutatie of een royement ongedaan.
 */
export const muterenMaakMutatieOngedaanOpProduct = (
  offertenummer: MaybeRef<string | undefined | null>,
  offerteproductId: MaybeRef<number | undefined | null>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  offertenummer = unref(offertenummer);
  offerteproductId = unref(offerteproductId);

  return customInstance<void>(
    {
      url: `/api/v1/muteren/${offertenummer}/${offerteproductId}/ongedaan-maken`,
      method: 'POST',
      signal,
    },
    options,
  );
};

export const getMuterenMaakMutatieOngedaanOpProductMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof muterenMaakMutatieOngedaanOpProduct>>,
    TError,
    { offertenummer: string | undefined | null; offerteproductId: number | undefined | null },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof muterenMaakMutatieOngedaanOpProduct>>,
  TError,
  { offertenummer: string | undefined | null; offerteproductId: number | undefined | null },
  TContext
> => {
  const mutationKey = ['muterenMaakMutatieOngedaanOpProduct'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof muterenMaakMutatieOngedaanOpProduct>>,
    { offertenummer: string | undefined | null; offerteproductId: number | undefined | null }
  > = (props) => {
    const { offertenummer, offerteproductId } = props ?? {};

    return muterenMaakMutatieOngedaanOpProduct(offertenummer, offerteproductId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type MuterenMaakMutatieOngedaanOpProductMutationResult = NonNullable<
  Awaited<ReturnType<typeof muterenMaakMutatieOngedaanOpProduct>>
>;

export type MuterenMaakMutatieOngedaanOpProductMutationError = ErrorType<void>;

/**
 * @summary Maakt een mutatie of een royement ongedaan.
 */
export const useMuterenMaakMutatieOngedaanOpProduct = <
  TError = ErrorType<void>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof muterenMaakMutatieOngedaanOpProduct>>,
      TError,
      { offertenummer: string | undefined | null; offerteproductId: number | undefined | null },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof muterenMaakMutatieOngedaanOpProduct>>,
  TError,
  { offertenummer: string | undefined | null; offerteproductId: number | undefined | null },
  TContext
> => {
  return useMutation(getMuterenMaakMutatieOngedaanOpProductMutationOptions(options), queryClient);
};
